import Generator from '../generator';
import { api } from 'utils/api-client';

const config = {
  entities: {
    api: {
      fetchItem: (type, { websiteId, ...args }, id) =>
        api.get(`/websites/${websiteId}/redirects/${id}`, args),
      updateItem: (type, { websiteId, ...args }, id) =>
        api.patch(`/websites/${websiteId}/redirects/${id}`, args),
      fetchList: (type, { websiteId, ...args }) =>
        api.get(`/websites/${websiteId}/redirects`, args),
      createItem: (type, { websiteId, ...args }) =>
        api.post(`/websites/${websiteId}/redirects`, args)
    }
  }
};

export default new Generator('redirects', config).createEntityModel();
